import { Grid } from 'telia-front-react';
import * as React from 'react';
import DayPackage from './DayPackage';
import MonthPackage from './MonthPackage';
import WeekPackage from './WeekPackage';

class RoamingPackages extends React.Component {
  public render() {
    return (
      <Grid align={['center-xs']} equalHeight={true}>
        <DayPackage />
        <WeekPackage />
        <MonthPackage />
      </Grid>
    );
  }
}

export default RoamingPackages;
